import { useCallback, useState } from 'react';
import { Panel, FlexRow, FlexSpacer, WarningAlert, Text } from '@epam/promo';
import { TaskGroupsList } from 'components/settings/TaskGroupList';
import { ReactComponent as plusIcon } from '@epam/assets/icons/common/content-add-outline-24.svg';
import { TaskGroupsForm } from 'components/settings/TaskGroupsForm';
import { useTaskGroupsGetAllQuery } from 'hooks';
import { IconContainer } from '@epam/uui-components';
import {
  setIsAlertShown,
  setIsControlsShown,
  useTaskGroupsStore,
} from 'store/task-groups';
import css from './TaskGroupsView.module.scss';

const MAX_AMOUNT_OF_GROUPS = 20;

export const TaskGroupsView = () => {
  const { taskGroups, isLoading } = useTaskGroupsGetAllQuery();
  const [isFormShown, setIsFormShown] = useState(false);
  const { isAlertShown, isControlsShown } = useTaskGroupsStore(
    (state) => state,
  );

  const handleClose = useCallback(() => {
    setIsFormShown(false);
  }, []);

  return (
    <Panel
      shadow
      background="white"
      cx={{
        [css.page__panel]: true,
        'skeleton-loader': isLoading,
      }}>
      <TaskGroupsList groups={taskGroups} />
      {isFormShown && (
        <div className={css.container}>
          <TaskGroupsForm onClose={handleClose} />
        </div>
      )}
      {taskGroups.length < MAX_AMOUNT_OF_GROUPS ? (
        <FlexRow>
          <FlexSpacer />
          <button
            className={css.page__button}
            disabled={isFormShown || !isControlsShown}
            type="submit"
            onClick={() => {
              setIsFormShown(true);
              setIsControlsShown(false);
            }}>
            <IconContainer cx={css.icon} icon={plusIcon} size={24} />
            add new group
          </button>
        </FlexRow>
      ) : (
        isAlertShown && (
          <div className={css.container}>
            <WarningAlert onClose={() => setIsAlertShown(false)}>
              <Text size="30">
                {`You created ${MAX_AMOUNT_OF_GROUPS} groups, that’s the limit. The creation option
                isn’t available.`}
              </Text>
            </WarningAlert>
          </div>
        )
      )}
    </Panel>
  );
};
